import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { useChat } from './ChatProvider';

export function ChatButton() {
  const { open } = useChat();

  return (
    <Tooltip title="BERP Assistant">
      <IconButton onClick={open} color="inherit" size="medium">
        <SmartToyOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
}
